import React, { useState, useEffect, useRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { Col, Row, Button, Container, Table } from "reactstrap";
import axios from "axios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import base_url from "../../api/bootapi";
import Nav from "../NavBar/Nav";
import FooterNew from "../NavBar/FooterNew";
import ReactToPrint from "react-to-print";
import PrintEnquiryStatus from "./PrintEnquiryStatus";
import PaymentModal from "./PaymentModal";
import NoteModal from "./NoteModal";
import RemarkModal from "./RemarkModal";
import Swal from "sweetalert2";

const ViewEnquiryStatus = () => {
  const { enquiry_id } = useParams(); // Extract enquiry_id from URL params
  const [enquiryData, setEnquiryData] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const navigate = useNavigate();
  const componentRef = useRef();
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [totalPrice, setTotalPrice] = useState(0);
  const [tourId, setTourId] = useState(null)

  const openPaymentModal = () => setPaymentModalOpen(true);
  const openRemarkModal = () => setRemarkModalOpen(true);
  const closePaymentModal = () => setPaymentModalOpen(false);
  const closeRemarkModal = () => setRemarkModalOpen(false);

  const handlePaymentSubmit = (event) => {
    event.preventDefault();
    // Handle payment submission logic here
    console.log("Payment amount:", amount);
    closePaymentModal(); // Close modal after submitting payment
  };

  useEffect(() => {


    fetchEnquiryData();
    getMiscellaneousDetails()

  }, [enquiry_id]);

  const getTotalCredit = (credits) => {
    const totalCredit = (credits ?? []).reduce(
      (sum, item) => sum + (Number(item.credit_amount) || 0),
      0
    );

    return totalCredit
  }


  useEffect(() => {
    if (tourId) {
      getTourDetails();
    }
  }, [tourId])

  const [otherCostDescription, setOtherCostDescription] = useState(null)

  const getTourDetails = () => {

    const tour_id = tourId;

    console.log(tour_id)
    setBackdropOpen(true);


    axios
      .get(`${base_url.api1}/tourapp/get_trip?id=${tour_id}`)
      .then((response) => {
        setBackdropOpen(false);

        if (response.data) {


          setOtherCostDescription(response.data?.Tour?.[0]?.other_cost_description || null);

          console.log(response.data?.Tour?.[0]?.other_cost_description)

        }
      })
      .catch((err) => {
        setBackdropOpen(false);

        console.log(err)
      });
  };

  const formatDollar = (amount) => {
    console.log(amount)
    if (!amount) {
      return "$0.00"
    }

    const txn_amount = Number(amount)

    if (txn_amount >= 0) {
      return `$${txn_amount}`
    } else {
      return `- $${txn_amount * -1}`

    }
  }

  const openDownModal = () => {
    Swal.fire({
      icon: "warning",
      title: "Payment Service Down",
      html: `
    <p>Merchant service is temporarily down.</p>
    <p>Please call the office at 
      <a href="tel:8453881104"><strong>845-388-1104</strong></a>
      to process your credit card payment.
    </p>
  `,
      confirmButtonText: "Got it"
    });
  }

  const fetchEnquiryData = async () => {

    let id;
    console.log(enquiry_id)
    if (enquiry_id.includes("_")) {
      id = enquiry_id.split("_")[0];

    } else {
      id = enquiry_id

    }

    setBackdropOpen(true);
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/trip_enquiry?id=${id}`
      );
      setEnquiryData(response.data.Enquiry[0]);
      console.log("Amounts =======> ", response.data.Enquiry[0]?.credits, response.data.Enquiry[0].pending_amount, response.data.Enquiry[0].total_price, getTotalCredit(response.data.Enquiry[0]?.credits))
      console.log(response.data.Enquiry[0].total_price - response.data.Enquiry[0].pending_amount - getTotalCredit(response.data.Enquiry[0]?.credits))
      setAmount(response.data.Enquiry[0].pending_amount);
      setTotalPrice(response.data.Enquiry[0].pending_amount)
      setTourId(response.data.Enquiry[0].tour_id)
      if (enquiry_id.includes("_")) {

        openPaymentModal()

        // openDownModal()
      }
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
    } finally {
      setBackdropOpen(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const goBack = () => {
    navigate(-1);
  };

  const [miscellaneousData, setMiscellaneousData] = useState([]);
  const getMiscellaneousDetails = () => {

    let id;
    console.log(enquiry_id)
    if (enquiry_id.includes("_")) {
      id = enquiry_id.split("_")[0];

    } else {
      id = enquiry_id

    }

    axios
      .get(`${base_url.api1}/tourapp/miscellaneous_cost?enquiry_id=${id}`)
      .then((response) => {
        if (response.data) {

          const miscellaneousData = response?.data?.miscellaneous_costs || [];
          setMiscellaneousData(miscellaneousData);

          console.log(miscellaneousData)

        }
      })
      .catch((err) => {
        console.log(err)
      });
  };

  const cardPayments = enquiryData?.Transactions?.filter(
    (t) => t.payment_method === "Card"
  );

  const otherPayments = enquiryData?.Transactions?.filter(
    (t) => t.payment_method !== "Card"
  );

  return (
    <>
      <Nav />
      <div className="container application_card">
        <div
          className="page-head d-flex justify-content-between p-4"
          style={{ marginTop: "1.3rem" }}
        >
          <ul className="breadcrums">
            <Link to="/" className="b-link">
              Home
            </Link>
            <span className="s_span ">&raquo;</span>
            <Link onClick={goBack} className="b-link">
              My Booking
            </Link>
            <span className="s_span ">&raquo;</span>
            <Link to="#" className="b-link active">
              Application Status
            </Link>
          </ul>
        </div>

        <Container className="enquiry-view-container">
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropOpen}
          >
            <CircularProgress color="inherit" />
          </Backdrop>

          <h4 style={{ marginBottom: "24px" }}>
            Application Details of{" "}
            <span style={{ color: "#1a6379" }}>
              {`${enquiryData.first_name || ""} ${enquiryData.middle_name || ""} ${enquiryData.last_name || ""}`}
            </span>
          </h4>

          {/* Personal Details Section */}
          <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Personal Details</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin2">
            <Row>
              <Col md={3}>
                <label>Last Name:</label>
                <p>{enquiryData.last_name}</p>
              </Col>

              <Col md={3}>
                <label>First Name:</label>
                <p>{enquiryData.first_name}</p>
              </Col>

              <Col md={3}>
                <label>Middle Name:</label>
                <p>{enquiryData?.middle_name ?? ''}</p>
              </Col>

              <Col md={3}>
                <label>Gender:</label>
                <p>{enquiryData.gender}</p>
              </Col>
              {enquiryData.date_of_birth && (
                <Col md={3} style={{ position: "relative" }}>
                  <label>Date Of Birth:</label>
                  <p>{moment(enquiryData.date_of_birth).format("MM-DD-YYYY")}</p>
                </Col>
              )}
              <Col md={3}>
                <label>Contact No.:</label>
                <p>{enquiryData.phone_number}</p>
              </Col>
              <Col md={3}>
                <label>Passport Number:</label>
                <p>{enquiryData.passport_number}</p>
              </Col>
              <Col md={3}>
                <label>Passport Expiration Date:</label>
                <p>

                  {enquiryData?.passport_expiration_date ? moment(enquiryData.passport_expiration_date).format(
                    "DD-MM-YYYY"
                  ) : ""}
                </p>
              </Col>
              <Col md={3}>
                <label>Email:</label>
                <p>{enquiryData.email_address}</p>
              </Col>
            </Row>
          </div>

          {/* Details Section */}
          <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Address</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin2">
            <Row>
              <Col md={3} style={{ position: "relative" }}>
                <label>Country:</label>
                <p>{enquiryData.nationality}</p>
              </Col>
              <Col md={3}>
                <label>State:</label>
                <p>{enquiryData.state}</p>
              </Col>
              <Col md={3}>
                <label>City:</label>
                <p>{enquiryData.city}</p>
              </Col>
              <Col md={3}>
                <label>Zip Code:</label>
                <p>{enquiryData.zip}</p>
              </Col>
              <Col md={3}>
                <label>Address:</label>
                <p>{enquiryData.address}</p>
              </Col>
            </Row>
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Tour Details</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin">
            <Row>
              <Col md={3}>
                <label>Interested Tour Name:</label>
                <p>{enquiryData.intrested_tour}</p>
              </Col>
              <Col md={3}>
                <label>Tour Start Date:</label>
                <p>
                  {moment(enquiryData.trip_start_date).format("MM-DD-YYYY")}
                </p>
              </Col>


              <Col md={3}>
                <label>Tour End Date:</label>
                <p>{moment(enquiryData.trip_end_date).format("MM-DD-YYYY")}</p>
              </Col>
              <Col md={6}>
                <label>Package:</label>
                <p>
                  {[
                    enquiryData.full_package && `Full Package (${formatDollar(enquiryData.full_package_price)})`,
                    enquiryData.accommodation_only && `Accommodation (${formatDollar(enquiryData.accommodation_only_price)})`,
                    enquiryData.insurance && `Insurance (${formatDollar(enquiryData.insurance_price)})`,
                    enquiryData.single_room_cost_only && `Single Room (${formatDollar(enquiryData.single_room_cost)})`,

                    enquiryData.other_cost_included && `Other Cost (${formatDollar(enquiryData.other_cost)})`
                  ]
                    .filter(Boolean)
                    .join(" | ")}
                </p>
              </Col>


              {/* <Col md={3}>
                <label>Package:</label>
                <p>
                  {enquiryData.accommodation_only
                    ? "Accommodation"
                    : "Ticket"}
                </p>
              </Col> */}
              {/* <Col md={3}>
                <label>Insurance:</label>
                <p>{enquiryData.insurance ? "Yes" : "No"}</p>
              </Col> */}
            </Row>

            <Row>



              <Col md={3}>
                <label>Special Ticket Preference</label>

                <p style={{ whiteSpace: 'pre-line' }}>
                  {enquiryData?.special_ticket_preference ?? "-"}
                </p>

              </Col>


              <Col md={3}>
                <label>Special Ticket Price</label>

                <p style={{ whiteSpace: 'pre-line' }}>
                  ${enquiryData?.special_ticket_price ? Number(enquiryData?.special_ticket_price).toFixed(2) : "0.00"}
                </p>

              </Col>

            </Row>

            {
              enquiryData?.other_cost_included && otherCostDescription && <div style={{ marginTop: '30px' }}>
                <div style={{ display: "flex", marginTop: "10px" }}>
                  <p className="provider_containertitle">Other Cost Description</p>
                  <hr style={{ flex: "1", marginLeft: "20px" }} />
                </div>

                <p style={{ whiteSpace: 'pre-line' }}>
                  {otherCostDescription}
                </p>

              </div>
            }


            {
              miscellaneousData?.length > 0 && <div>


                <div style={{ display: "flex", marginTop: "40px", }} >
                  <p className="provider_containertitle">Miscellaneous Details</p>
                  <hr style={{ flex: "1", marginLeft: "20px" }} />
                </div>

                {
                  miscellaneousData?.length === 0 && <p>No Data</p>
                }

                {
                  miscellaneousData && miscellaneousData?.length > 0 && <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "25%" }}>Cost Description</th>
                        <th style={{ width: "15%" }}>Cost Amount</th>

                        <th style={{ width: "15%" }}>Date</th>


                      </tr>
                    </thead>
                    <tbody>
                      {miscellaneousData.map((transaction, index) => (
                        <tr key={transaction.id}>
                          <td>{index + 1}</td>
                          <td>{transaction.cost_description}</td>

                          <td>
                            {formatDollar(transaction?.cost_amount)}
                          </td>

                          <td> {new Date(
                            transaction?.created_date
                          ).toLocaleDateString()}</td>





                        </tr>
                      ))}
                    </tbody>
                  </Table>}
              </div>
            }



            {
              enquiryData?.credits?.length > 0 && <div>


                <div style={{ display: "flex", }} >
                  <p className="provider_containertitle">Credit Details</p>
                  <hr style={{ flex: "1", marginLeft: "20px" }} />
                </div>

                {
                  enquiryData?.credits?.length === 0 && <p>No Data</p>
                }

                {
                  enquiryData?.credits && enquiryData?.credits?.length > 0 && <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "25%" }}>Credit Description</th>
                        <th style={{ width: "15%" }}>Credit Amount</th>

                        <th style={{ width: "15%" }}>Date</th>


                      </tr>
                    </thead>
                    <tbody>
                      {enquiryData?.credits.map((transaction, index) => (
                        <tr key={transaction.id}>
                          <td>{index + 1}</td>
                          <td>{transaction.credit_description}</td>

                          <td>
                            {formatDollar(transaction?.credit_amount)}
                          </td>

                          <td> {new Date(
                            transaction?.created_date
                          ).toLocaleDateString()}</td>





                        </tr>
                      ))}
                    </tbody>
                  </Table>}

              </div>
            }

          </div>

          {/* Card Details Section */}
          {/* {enquiryData.payment_method === "Card" && (
            <>
              <div style={{ display: "flex", marginTop: "10px" }}>
                <p className="provider_containertitle">Card Details</p>
                <hr style={{ flex: "1", marginLeft: "20px" }} />
              </div>
              <div className="form-group creatadmin">
                <Row>
                  <Col md={3}>
                    <label>Payment Method:</label>
                    <p>{enquiryData.payment_method}</p>
                  </Col>
                  <Col md={3}>
                    <label>Card Holder Name:</label>
                    <p>{enquiryData.card_holder_name}</p>
                  </Col>
                  <Col md={2}>
                    <label>Card No.:</label>
                    <p>{enquiryData.card_number}</p>
                  </Col>
                  <Col md={2}>
                    <label>Expiry Date:</label>
                    <p>
                      {enquiryData.card_expiry_month &&
                      enquiryData.card_expiry_year
                        ? `${enquiryData.card_expiry_month}/${enquiryData.card_expiry_year}`
                        : ""}
                    </p>
                  </Col>
                  <Col md={2}>
                    <label>CVV:</label>
                    <p>{enquiryData.card_cvv}</p>
                  </Col>
                </Row>
              </div>
            </>
          )} */}

          {/* Payment Details Section */}
          <div style={{ display: "flex", marginTop: "40px" }}>
            <p className="provider_containertitle">Payment Details</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin">
            <Row>


              {
                enquiryData?.Transactions?.length === 0 && <p>No transaction details found.</p>
              }
              {
                cardPayments && cardPayments?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th style={{ width: "15%" }}>Payment Method</th>
                      <th style={{ width: "10%" }}>Card Number</th>
                      <th style={{ width: "24%" }}>Transaction ID</th>
                      <th>Zip Code</th>
                      <th>Payment From</th>
                      <th>Charge Amount</th>
                      <th>Payment Applied Amount</th>
                      <th>Date</th>
                      {/* <th>Payment Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {cardPayments.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{index + 1}</td>
                        <td>{transaction.payment_method}</td>

                        <td>
                          {transaction.card_number !== "Non" ? (
                            <p style={{ margin: 0 }}>******{transaction.card_number}</p>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td>{transaction.transaction_id}</td>


                        <td>{transaction?.billing_zip ? transaction?.billing_zip : "-"}</td>
                        <td style={{ display: "flex", gap: "10px" }}>{transaction.payment_from} </td>
                        <td>{transaction?.card_fee ? formatDollar(Number(transaction.amount) + Number(transaction.card_fee)) : formatDollar(transaction.amount)}</td>

                        <td>{formatDollar(transaction.amount)}</td>
                        <td>
                          {new Date(
                            transaction.created_date
                          ).toLocaleDateString()}
                        </td>
                        {/* <td>
                          {transaction.recieved ? "Received" : "Not Received"}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }

              {
                otherPayments && otherPayments?.length > 0 && <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th style={{ width: "5%" }}>#</th>
                      <th style={{ width: "15%" }}>Payment Method</th>
                      <th style={{ width: "34%" }}>Note</th>


                      <th>Zip Code</th>
                      <th>Payment From</th>
                      <th>Charge Amount</th>
                      <th>Payment Applied Amount</th>
                      <th>Date</th>
                      {/* <th>Payment Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {otherPayments.map((transaction, index) => (
                      <tr key={transaction.id}>
                        <td>{cardPayments?.length + index + 1}</td>
                        <td>{transaction.payment_method}</td>



                        <td>{transaction?.note ?? "-"}</td>


                        <td>{transaction?.billing_zip ? transaction?.billing_zip : "-"}</td>
                        <td style={{ display: "flex", gap: "10px" }}>{transaction.payment_from} </td>
                        <td>{transaction?.card_fee ? formatDollar(Number(transaction.amount) + Number(transaction.card_fee)) : formatDollar(transaction.amount)}</td>

                        <td>{formatDollar(transaction.amount)}</td>
                        <td>
                          {new Date(
                            transaction.created_date
                          ).toLocaleDateString()}
                        </td>
                        {/* <td>
                          {transaction.recieved ? "Received" : "Not Received"}
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }



            </Row>

            <Row >

              <Col md={2}>
                <label>Total Cost:</label>
                <p>
                  {formatDollar(enquiryData?.total_price)}
                </p>
              </Col>

              <Col md={2}>
                <label>Total Paid:</label>
                <p>
                  {formatDollar(enquiryData.total_price - enquiryData.pending_amount - getTotalCredit(enquiryData.credits))}
                </p>
              </Col>

              <Col md={2}>
                <label>Credit:</label>
                <p>
                  {formatDollar(getTotalCredit(enquiryData.credits))}
                </p>
              </Col>

              <Col md={2}>
                <label>Open Balance:</label>
                <p>
                  {formatDollar(enquiryData.pending_amount)}
                </p>
              </Col>
            </Row>
          </div>
          <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Billing Address</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin">
            <Row>
              <Col md={3}>
                <label>Country:</label>
                <p>{enquiryData.billing_country}</p>
              </Col>
              <Col md={3}>
                <label>State:</label>
                <p>{enquiryData.billing_state}</p>
              </Col>
              <Col md={3}>
                <label>City:</label>
                <p>{enquiryData.billing_city}</p>
              </Col>
              <Col md={3}>
                <label>Zip Code:</label>
                <p>{enquiryData.billing_zip}</p>
              </Col>
              <Col md={3}>
                <label>Address:</label>
                <p>{enquiryData.billing_address}</p>
              </Col>
            </Row>
          </div>

          <div style={{ display: "flex", marginTop: "10px" }}>
            <p className="provider_containertitle">Remarks</p>
            <hr style={{ flex: "1", marginLeft: "20px" }} />
          </div>
          <div className="form-group creatadmin">
            <Row>
              <Col md={12}>
                <p style={{ whiteSpace: "pre-line" }}>{enquiryData?.remarks || "No Remarks found"}</p>
              </Col>
            </Row>
          </div>

          {/* Buttons at the end */}
          <Row
            className="mt-4 gap-2"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              color="primary"
              onClick={openRemarkModal}
              style={{ width: "200px" }}
            >
              Add Remark
            </Button>

            <ReactToPrint
              trigger={() => (
                <Button
                  color="primary"
                  style={{ width: "200px" }}
                >
                  Print
                </Button>
              )}
              content={() => componentRef.current}
            />

            <Button
              color="success"
              onClick={openPaymentModal}
              style={{ width: "200px" }}
            >
              Make Payment
            </Button>
            {/* <Col
              className="text-right"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <ReactToPrint
                trigger={() => (
                  <Button
                    color="primary"
                    style={{ width: "200px" }}
                  >
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />

              <Button
                color="success"
                onClick={openPaymentModal}
                style={{ width: "200px" }}
              >
                Make Payment
              </Button>
            </Col> */}
          </Row>
          <div style={{ display: "none" }}>
            <PrintEnquiryStatus ref={componentRef} enquiryData={enquiryData} otherCostDescription={otherCostDescription} miscellaneousData={miscellaneousData} />
          </div>
        </Container>
      </div>
      <FooterNew />




      <PaymentModal
        totalPrice={totalPrice}
        enquiryData={enquiryData}
        isOpen={paymentModalOpen}
        onRequestClose={closePaymentModal}
        amount={amount}
        setAmount={setAmount}
        setbackdropopen={setBackdropOpen}
        enquiry_id={enquiry_id}
        fetchEnquiryData={fetchEnquiryData}


      />

      <RemarkModal

        remark={enquiryData?.remarks ?? ''}
        isOpen={remarkModalOpen}
        onRequestClose={closeRemarkModal}


        setbackdropopen={setBackdropOpen}
        enquiry_id={enquiry_id}
        fetchEnquiryData={fetchEnquiryData}
      />


    </>
  );
};

export default ViewEnquiryStatus;
